import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../atoms/Image';
import MarkdownContent from '../../../../../../components/MarkdownContent/MarkdownContent';
import WebsiteComponentInteraction from '../../../../../interactions/components/WebsiteComponentInteraction';
import { INTERACTION_DISPLAY_TYPE_ICON } from '../../../../../interactions/constants';
import { splitInteractionsIntoClickthroughAndLink } from '../../../../../interactions/utils';
import { PriceRange } from '../../../../../money/components';
import { getItemModifierSets } from '../../../../services/catalog';
import { MenuCatalogItemPropType, MenuCatalogModifierPropType, MenuCatalogModifierSetPropType } from '../../../../types/menu-catalog';
import ModifierSetsAccordions from '../../../ModifierSetsAccordions';
import { FIRST_PRICE_DISPLAY_TYPE } from '../../ServicesList.constants';
import { PriceDisplayTypePropTypes } from '../../types/price-display';
import './ServicesListItem.css';
var defaultProps = {
  modifierSets: [],
  modifiers: [],
  priceDisplayType: FIRST_PRICE_DISPLAY_TYPE,
  displayZeroCostItemPrices: false,
  precision: 2,
  displayImage: true
};
export default function ServicesListItem(_ref) {
  var item = _ref.item,
    modifierSets = _ref.modifierSets,
    modifiers = _ref.modifiers,
    priceDisplayType = _ref.priceDisplayType,
    displayZeroCostItemPrices = _ref.displayZeroCostItemPrices,
    precision = _ref.precision,
    displayImage = _ref.displayImage;
  var variations = item.variations,
    name = item.name,
    image = item.image,
    gatsbyImage = item.gatsbyImage,
    description = item.description,
    _item$interactions = item.interactions,
    interactions = _item$interactions === void 0 ? [] : _item$interactions,
    imageAltText = item.imageAltText;
  var photo = gatsbyImage || image;
  var _splitInteractionsInt = splitInteractionsIntoClickthroughAndLink(interactions),
    _splitInteractionsInt2 = _slicedToArray(_splitInteractionsInt, 2),
    clickThroughInteractions = _splitInteractionsInt2[0],
    linkInteractions = _splitInteractionsInt2[1];
  var nameContent = name;
  if (clickThroughInteractions.length > 0) {
    nameContent = /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
      interaction: _objectSpread(_objectSpread({}, clickThroughInteractions[0]), {}, {
        displayType: INTERACTION_DISPLAY_TYPE_ICON
      }),
      content: name
    });
  }
  var imageColumnWidth = 2;
  var nameColumnWidth = displayImage ? 9 : 11;
  var priceColumnWidth = 5;
  var itemModifierSets = getItemModifierSets(item, modifierSets);
  return /*#__PURE__*/React.createElement(Grid, {
    className: "services-list-item"
  }, displayImage && /*#__PURE__*/React.createElement(Grid.Column, {
    width: imageColumnWidth,
    className: "image-column"
  }, !_isEmpty(photo) && /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "photo",
    src: photo,
    altText: imageAltText
  }))), /*#__PURE__*/React.createElement(Grid.Column, {
    width: nameColumnWidth,
    className: "name-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, nameContent), !_isEmpty(description) && /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, /*#__PURE__*/React.createElement(MarkdownContent, null, description)), !_isEmpty(itemModifierSets) && /*#__PURE__*/React.createElement("div", {
    className: "modifier-sets"
  }, /*#__PURE__*/React.createElement(ModifierSetsAccordions, {
    modifierSets: itemModifierSets,
    modifiers: modifiers,
    defaultOpenIndices: []
  })), linkInteractions && /*#__PURE__*/React.createElement("div", {
    className: "item-interaction-link"
  }, linkInteractions.map(function (interaction) {
    return /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
      interaction: interaction
    });
  }))), /*#__PURE__*/React.createElement(Grid.Column, {
    width: priceColumnWidth,
    className: "price-column",
    textAlign: "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, /*#__PURE__*/React.createElement(PriceRange, {
    prices: variations.map(function (_ref2) {
      var price = _ref2.price;
      return {
        amount: price
      };
    }),
    settings: {
      precision: precision,
      displayType: priceDisplayType,
      displayZeroCost: displayZeroCostItemPrices
    },
    as: null
  }))));
}
ServicesListItem.defaultProps = defaultProps;